var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mp_url.length > 0)?_c('div',{staticClass:"article-box",on:{"click":_vm.openArticle}},[_c('van-image',{staticClass:"mp-icon",attrs:{"src":"https://cdn-xcxcustom.weiyoubot.cn/20210610/fb62698897e2cecce16246ecd18ca39b.png"}}),_vm._v(" "),_c('div',{staticClass:"mp-title"},[_vm._v(_vm._s(_vm.mp_title))])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-330dd444","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ArticleBox.vue
// module id = null
// module chunks = 